let activePrice

if ($('body').hasClass('template-product')) {
  $('.variant-selector p').on('click', function () {
    const index = $(this).index()
    $(`#productSelect-option-0 open`).prop('selected', false)
    $(`#productSelect-option-0 option:eq(${index})`).prop('selected', true)
    $('#productSelect-option-0').change()

    $('.variant-selector p').removeClass('selected')
    $(this).addClass('selected')
  })

  const throttle = (func, limit) => {
    let inThrottle
    return function () {
      const args = arguments
      const context = this
      if (!inThrottle) {
        func.apply(context, args)
        inThrottle = true
        setTimeout(() => (inThrottle = false), limit)
      }
    }
  }

  window.updateProductPrice = function () {

    var discount = $('.rc_label__discount').length ? (100 - Number($('.rc_label__discount').text().split('(')[1].split('%')[0])) / 100 : 0
    const discounted = activePrice * discount
    const discountedHTML = Shopify.formatMoney(discounted)
    const discountDollars = Math.round((1 - discount) * activePrice)

    if ($('.rc_block__type--active [name="purchase_type"]').val() == 'autodeliver') {
      $('#discount-dollars').html('$' + discountDollars / 100)
      $('.product-priceee, #product-discounted, .product-sticky .product-price').html(discountedHTML)
      $('.product-original-price').html(Shopify.formatMoney(activePrice))
    } else {
      $('#product-discounted').html(discountedHTML)

      $('.product-priceee, .product-original-price, .product-sticky .product-price').html(
        Shopify.formatMoney(activePrice)
      )
    }
  }

  $('[name="purchase_type"]').on('change', function () {
    const selectedValue = $(this).val()

    // Sync all purchase_type radio buttons on the page
    $('[name="purchase_type"]').each(function() {
      if ($(this).val() === selectedValue) {
        $(this).prop('checked', true)
        $(this).closest('.rc_block__type').addClass('rc_block__type--active')
      } else {
        $(this).prop('checked', false)
        $(this).closest('.rc_block__type').removeClass('rc_block__type--active')
      }
    })

    window.updateProductPrice()
  })

  var selectFired = false

  window.productSelect = ({ variant }, selector) => {
    activePrice = variant.price

    window.updateProductPrice()

    if (variant.available) {
      $('#AddToCart').removeClass('out-of-stock').prop('disabled', false)
    } else {
      $('#AddToCart').addClass('out-of-stock').prop('disabled', true)
    }

    if ($('.variant-included').length) {
      $('.variant-included').hide()
      $('.variant-included[data-id="' + variant.id + '"]').show()
    }

    if (!selectFired) {
      selectFired = true
      $('.product-top-left').slick({ arrows: true })
    }

    $('.product-top-left').slick('slickGoTo', variant.featured_image.position - 1)
  }

  $(document).ready(function () {
    $('.home-start-slider').slick({
      responsive: [
        {
          breakpoint: 959,
          settings: {
            centerMode: true,
            variableWidth: true,
          },
        },
      ],
    })
  })

  $(window).on(
    'scroll',
    throttle(function () {
      const pos = $(window).scrollTop()

      if ($('#whats-in-it').length) {
        const posWin = pos + $(window).height()
        const what = $('#whats-in-it').offset().top
        const how = $('#how-to-use').offset().top
        const plant = $('#plant-profile').offset().top
        const footer = $('.footer').offset().top
        /* if (posWin >= $('.footer').offset().top) {
        $('.product-side').removeClass('active')
        $('.product-side li').removeClass('active')
      } */
        if (pos >= plant + 200) {
          $('.product-side').removeClass('active')
          $('.product-side li').removeClass('active')
        } else if (pos > plant - 104) {
          $('.product-side').addClass('active')
          $('.product-side li').removeClass('active')
          $('.product-side li').eq(0).addClass('active')
        } else if (pos > how - 104) {
          $('.product-side').addClass('active')
          $('.product-side li').removeClass('active')
          $('.product-side li').eq(1).addClass('active')
        } else if (pos > what - 104) {
          $('.product-side').addClass('active')
          $('.product-side li').removeClass('active')
          $('.product-side li').eq(2).addClass('active')
        } else {
          $('.product-side').removeClass('active')
          $('.product-side li').removeClass('active')
        }
      }

      if (pos > 600) {
        $('.product-sticky').addClass('active')
      } else {
        $('.product-sticky').removeClass('active')
      }
    }, 20)
  )
}

$(document).ready(function () {
  if ($('.product-customer-blocks').length) {
    $('.product-customer-blocks').slick({
      slidesToShow: 1,
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      autoplay: true,
    })
  }
})
